import { useEffect, useState } from "react";
import AdminLayout from "layouts/AdminLayout";
import AdminCard from "components/admin/AdminCard";
import CustomBarChart from "components/CustomBarChart";
import CustomPieChart from "components/CustomPieChart";
import { Button } from "components/ui/button";
import {
  getEnviosPorCliente,
  getShopifyXNuvemshopReport,
  getUpsXFedexReport,
  getCrescimentoMensalReport,
  getPaisesDestino,
} from "services/admin/adminRelatorios.service";
import { ChartPoint } from "services/admin/adminCommon.types";

const AdminRelatorios = () => {
  const [enviosPorCliente, setEnviosPorCliente] = useState<ChartPoint[]>([]);
  const [shopifyXNuvemshop, setShopifyXNuvemshop] = useState<ChartPoint[]>([]);
  const [upsXFedex, setUpsXFedex] = useState<ChartPoint[]>([]);
  const [crescimento, setCrescimento] = useState<ChartPoint[]>([]);
  const [paises, setPaises] = useState<ChartPoint[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getEnviosPorCliente(),
      getShopifyXNuvemshopReport(),
      getUpsXFedexReport(),
      getCrescimentoMensalReport(),
      getPaisesDestino(),
    ])
      .then(([a, b, c, d, e]) => {
        setEnviosPorCliente(a);
        setShopifyXNuvemshop(b);
        setUpsXFedex(c);
        setCrescimento(d);
        setPaises(e);
      })
      .catch((err) => console.error("[AdminRelatorios] erro:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout
      title="Relatórios"
      subtitle="Relatórios administrativos"
      action={
        <Button variant="outline" disabled title="Exportação em breve">
          Exportar
        </Button>
      }
    >
      {loading ? (
        <p className="text-sm text-muted-foreground">Carregando...</p>
      ) : (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <AdminCard title="Envios por cliente">
            <CustomBarChart
              data={enviosPorCliente}
              xKey="label"
              series={[{ key: "value", label: "Envios", color: "#2563EB" }]}
            />
          </AdminCard>
          <AdminCard title="Crescimento mensal">
            <CustomBarChart
              data={crescimento}
              xKey="label"
              series={[{ key: "value", label: "Novos clientes", color: "#90AEEF" }]}
            />
          </AdminCard>
          <AdminCard title="Shopify x Nuvemshop">
            <CustomPieChart data={shopifyXNuvemshop} />
          </AdminCard>
          <AdminCard title="UPS x FedEx">
            <CustomPieChart data={upsXFedex} />
          </AdminCard>
          <AdminCard title="Países de destino" className="xl:col-span-2">
            <CustomBarChart
              data={paises}
              xKey="label"
              series={[{ key: "value", label: "Envios", color: "#0E172B" }]}
            />
          </AdminCard>
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminRelatorios;
